import createPlugin from './createPlugin'

import MenuItemsCarouselRenderer from './Renderer/MenuItemsCarouselRenderer'

const menuItemsCarouselPlugin = settings =>
    createPlugin({
        Renderer: MenuItemsCarouselRenderer,
        ...settings,
    })

const menuItemsCarousel = menuItemsCarouselPlugin()
export default menuItemsCarousel

export { menuItemsCarouselPlugin, MenuItemsCarouselRenderer }
